import { render, staticRenderFns } from "./AutomationBase.vue?vue&type=template&id=fd30ce20&"
import script from "./AutomationBase.vue?vue&type=script&lang=js&"
export * from "./AutomationBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports